var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgClosePopup = function SvgClosePopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M7.2 5.999l4.8 4.8 4.8-4.8a.85.85 0 111.202 1.202l-4.8 4.8L18 16.799A.85.85 0 1116.797 18l-4.8-4.8-4.8 4.8a.85.85 0 01-1.201-1.202l4.802-4.802-4.8-4.8A.85.85 0 017.2 5.995z",
    fill: "#fff"
  })));
};
export default SvgClosePopup;